module.exports = __webpack_public_path__ + "img/qixian_6.6f6a0d05.png";